<div class="policy-explorer-page">
  <ng-container *ngIf="routeReady; else invalidRoute">
    <wc-policy-explorer [clientId]="clientId"
                        [schemaName]="schemaName"
                        [tableName]="tableName"
                        [recordId]="recordId"
                        [dataSetId]="dataSetId">
    </wc-policy-explorer>
  </ng-container>

  <ng-template #invalidRoute>
    <div class="route-error">
      {{ routeError || 'Invalid policy explorer route.' }}
    </div>
  </ng-template>
</div>
